const ServerUtil = {
	getDatadogEnvironment(): string {
		return window.datadogEnvironment || "gcw-prod";
	},

	getDatadogRumSampleRate(): number {
		return parseInt(window.datadogRumSampleRate) || 5;
	},

	getDatadogRumPremiumSampleRate(): number {
		return parseInt(window.datadogRumPremiumSampleRate) || 100;
	},

	isDatadogSessionReplayEnabled(): boolean {
		return window.datadogSessionReplayEnabled === true || window.datadogSessionReplayEnabled === "true" || false;
	},

	isPerformanceTrackingEnabled(): boolean {
		return window.performanceTrackingEnabled === true || window.performanceTrackingEnabled === "true" || false;
	},

	getGcpProjectId(): string {
		return window.gcpProjectId || "unknown";
	},
};
export default ServerUtil;
